import { useTranslation } from 'react-i18next';
import { checkoutI18n, currentLocale, LOCALE_OPTIONS, setCheckoutLocale, tr } from '../i18n';

export function LanguageSelector() {
  useTranslation(undefined, { i18n: checkoutI18n });
  return (
    <label className="vp-language-selector">
      <span>{tr('language.select')}</span>
      <select
        aria-label={tr('language.select')}
        value={currentLocale()}
        onChange={(event) => setCheckoutLocale(event.target.value as (typeof LOCALE_OPTIONS)[number]['locale'])}
      >
        {LOCALE_OPTIONS.map((option) => (
          <option key={option.locale} value={option.locale} lang={option.locale}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
}
